import React, { useEffect, useState } from 'react';
import { Box, Card, CardContent, CircularProgress, Grid } from '@material-ui/core';
import NVD3Chart from 'react-nvd3';
import { useDispatch, useSelector } from 'react-redux';
import { getReportsAction } from 'src/store/actions/ReportsActions';
import { AppNewUsers } from 'src/components/_dashboard/app';
import ReportCard from 'src/components/_dashboard/app/ReportCard';
import FilterReports from './components/FilterReports';
import { toast } from 'react-toastify';
import { fNumber, fShortenNumber } from 'src/utils/formatNumber';
import moment from 'moment';

const ReportsModule = () => {
  const [filterLoader, setFilterLoader] = useState(false);
  const dispatch = useDispatch();
  const { REPORTS, isLoading } = useSelector((state) => state.reports);

  useEffect(() => {
    const payload = {
      from: moment().subtract(1, 'd').unix(),
      to: moment().unix()
    };
    dispatch(getReportsAction(payload));
  }, []);

  const adsData = [
    {
      key: 'Ads Data',
      values: [
        {
          label: 'All Ads',
          value: fShortenNumber(REPORTS?.totalAds),
          color: '#04a9f5'
        },
        {
          label: 'Active',
          value: fShortenNumber(REPORTS?.totalActiveAds),
          color: '#ff8a65'
        },
        {
          label: 'Inactive',
          value: fShortenNumber(REPORTS?.totalInactiveAds),
          color: '#ff8a65'
        },
        {
          label: 'Assigned',
          value: fShortenNumber(REPORTS?.totalAssignedAds),
          color: '#1de9b6'
        },
        {
          label: 'Blocked',
          value: fShortenNumber(REPORTS?.totalBlockedAds),
          color: '#4C5667'
        }
      ]
    }
  ];

  // const adsDataset = [
  //   {
  //     name: 'All Ads',
  //     value: fShortenNumber(REPORTS?.totalAds),
  //     color: '#04a9f5'
  //   },
  //   {
  //     name: 'Active',
  //     value: fShortenNumber(REPORTS?.totalActiveAds)
  //   },
  //   {
  //     name: 'Inactive',
  //     value: fShortenNumber(REPORTS?.totalInactiveAds)
  //   },
  //   {
  //     name: 'Assigned',
  //     value: fShortenNumber(REPORTS?.totalAssignedAds)
  //   },
  //   {
  //     name: 'Blocked',
  //     value: fShortenNumber(REPORTS?.totalBlockedAds)
  //   }
  // ];

  const _handleFilterReports = async (values) => {
    setFilterLoader(true);
    const response = await dispatch(getReportsAction(values));
    if (response?.error === 1) {
      toast.info(`${response.message}`);
    }
    setFilterLoader(false);
  };

  return (
    <>
      <FilterReports handleFilter={_handleFilterReports} loading={filterLoader} />
      <Grid container style={{ marginBottom: 10 }} spacing={4}>
        {isLoading && (
          <Grid item sm={12}>
            <Box sx={{ textAlign: 'center' }}>
              <CircularProgress />
            </Box>
          </Grid>
        )}
        <Grid item md={6}>
          <AppNewUsers value={fNumber(REPORTS?.totalViews)} title="Total Views" />
        </Grid>
        <Grid item md={3}>
          <AppNewUsers value={REPORTS?.vendorsCount} title="Total Vendors" />
        </Grid>
        <Grid item md={3}>
          <AppNewUsers value={REPORTS?.adminsCount} title="Total Admins" />
        </Grid>
      </Grid>
      <Grid spacing={4} container style={{ marginBottom: 10 }}>
        <Grid item md={4}>
          <ReportCard
            main_title="Topup"
            value={REPORTS?.totalSelfTopupSum}
            sub_title="Count"
            count={REPORTS?.totalSelfTopupCount}
          />
        </Grid>
        <Grid item md={4}>
          <ReportCard
            main_title="System Topup"
            value={REPORTS?.totalSystemTopupSum}
            sub_title="System Topup Count"
            count={REPORTS?.totalSystemTopupCount}
          />
        </Grid>
        <Grid item md={4}>
          <ReportCard
            main_title="Total Topup"
            value={REPORTS?.totalTopupSum}
            sub_title="Topup Count"
            count={REPORTS?.totalTopupCount}
          />
        </Grid>
      </Grid>
      <Grid container spacing={4} style={{ marginBottom: 10, marginTop: 20 }}>
        <Grid item md={6}>
          <h3>Ads Report</h3>

          <Card>
            <CardContent style={{ padding: '20px', borderWidth: '2px' }}>
              <NVD3Chart
                tooltip={{ enabled: true }}
                type="discreteBarChart"
                datum={adsData}
                x="label"
                y="value"
                height={300}
                showValues
                staggerLabels
              />

              {/* <BarCharts data={adsDataset} dataKey={'value'} /> */}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export default ReportsModule;
